import { render, staticRenderFns } from "./InventoryEdit.vue?vue&type=template&id=4d4482f1&"
import script from "./InventoryEdit.vue?vue&type=script&lang=ts&"
export * from "./InventoryEdit.vue?vue&type=script&lang=ts&"
import style0 from "./Inventory.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports